<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-envelopes-bulk fa-fw" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <div class="tile-title">{{comm.subject}}</div>
            <div class="meta"><i class="far fa-calendar mr-2 fa-fw"></i>{{comm.created_at | moment('MMMM Do YYYY, h:mm:ss a')}}</div>
            <div class="meta mt-1"><i class="far fa-at mr-2 fa-fw"></i>{{comm.to}}</div>
        </template>
        <template v-slot:details>
            <div class="mt-3">
<!--                <toolbar class="toolbar">-->
<!--                    <button class="icon-only" @click.stop=""><i class="far fa-pencil"></i></button>-->
<!--                </toolbar>-->

                <div class="data mt-1">
                    <data-row mini title="To">{{comm.to}}</data-row>
                    <data-row mini title="From">{{comm.from}}</data-row>
                    <data-row mini title="Subject">{{comm.subject}}</data-row>
                    <data-row mini title="Created">{{comm.created_at | moment('MMMM Do YYYY, h:mm:ss a')}}</data-row>
                    <data-row mini title="ID">{{comm.message_id}}</data-row>
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "@/TIER/components/Toolbar";
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";

    export default {
        name: 'PlanCommunicationTile',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            card: {
                required: true
            },
            comm: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                details: false,
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }
</style>
